export const magasineFixture = ({
  link = 'https://www.calameo.com/read/0048301370582c4cca617',
  title = 'Dernier magazine', type = 'ALLO DIX HUIT',
  image = '/assets/images/magasine-09-2026.png'
} = {}) => ({
  link,
  title,
  type,
  image
});